import PortalTooltip from './PortalTooltip';

export default PortalTooltip;
